module.exports = {"370883001":"钢山街道","370883002":"千泉街道","370883003":"凫山街道","370883101":"香城镇","370883102":"城前镇","370883103":"大束镇","370883104":"北宿镇","370883105":"中心店镇","370883106":"唐村镇","370883107":"太平镇","370883109":"石墙镇","370883110":"峄山镇","370883111":"看庄镇","370883112":"张庄镇","370883113":"田黄镇","370883114":"郭里镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370883.json
// module id = 1324
// module chunks = 0